// TEMPLATE TODO: update path and action type
export var apiPath='/v2/integrations';var actionType='INTEGRATIONS';export var bulkActionType="".concat(actionType,"_BULK");export default actionType;